/**
 * Funnel series style overrides.
 *
 * Applies sort direction, gap size, and conversion-rate labels
 * ("X% of previous" between funnel steps).
 */
import type { EChartsOption } from 'echarts';
import type { TypeStyle } from '../../../../../edit/visualConfig';

export function applyFunnelOverrides(option: EChartsOption, cs: TypeStyle): EChartsOption {
  if (!Array.isArray(option.series)) return option;

  const result = { ...option };
  result.series = (result.series as any[]).map((s: any) => {
    if (s.type !== 'funnel') return s;

    const patched: any = {
      ...s,
      sort: cs.sortDescending ? 'descending' : 'none',
      gap: cs.gapSize ?? 1,
    };

    // Conversion rate labels: show "X% of previous" between steps
    if (cs.showConversion && Array.isArray(patched.data) && patched.data.length > 1) {
      const sorted = cs.sortDescending
        ? [...patched.data].sort((a: any, b: any) => (b.value ?? 0) - (a.value ?? 0))
        : patched.data;

      patched.label = {
        ...patched.label,
        show: true,
        position: 'inside',
        formatter: (params: any) => {
          const idx = params.dataIndex;
          const name = params.name ?? '';
          const val = params.value ?? 0;
          if (idx === 0) return name;
          const prev = sorted[idx - 1]?.value ?? 0;
          const rate = prev > 0 ? ((val / prev) * 100).toFixed(1) : '0';
          return `${name}\n${rate}%`;
        },
      };
    }

    return patched;
  });

  return result;
}